import * as React from 'react'

import LoadingSpinner from '../icons/loadingSpinner'

import * as styles from './loadingSpinnerPlaceholder.module.css'

const LoadingSpinnerPlaceholder = () => (
  <div className={styles.root}>
    <LoadingSpinner />
  </div>
)

export default LoadingSpinnerPlaceholder
